import { useSentryError } from "@/store/sentry-error.context";
import * as Sentry from "@sentry/react";

const SentryErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const { setEventId } = useSentryError();

  return (
    <Sentry.ErrorBoundary
      fallback={<div>Ha ocurrido un error inesperado.</div>}
      onError={(_, __, eventId) => {
        setEventId(eventId);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
